import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CSV_CONFIG_VALUES, CSV_TEMPLATE_VALUES } from 'src/app/dashboard/constants';

@Component({
  selector: 'app-csv-config',
  templateUrl: './csv-config.dialog.html',
  styleUrls: ['./csv-config.dialog.scss']
})
export class CsvConfigDialog implements OnInit {
  
  mode='Import';
  dropdownValues = CSV_CONFIG_VALUES;
  templateDropdownVal = CSV_TEMPLATE_VALUES;
  csvConfigForm:FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CsvConfigDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.mode = data;
    }

  ngOnInit(): void {
    this.csvConfigForm = new FormGroup({
      template: new FormControl(1),
      comment: new FormControl({value:0, disabled:true},),
      elevation: new FormControl({value:0,disabled:true}),
      name: new FormControl({value:3,disabled:true},[Validators.required]),
      latitude: new FormControl({value:2,disabled:true}, [Validators.required]),
      longitude: new FormControl({value:1,disabled:true}, [Validators.required]),
      useLocalSettings : new FormControl({value:false,disabled:true}, [Validators.required]),
      columnSeperator: new FormControl({value:',',disabled:true}),
      decimalSeperator: new FormControl({value:'.',disabled:true}),
    });

    this.onTemplateValChange();
  }

  cancel(): void {
    this.dialogRef.close({saveData :false});
  }
  onSubmit():void {
    if(this.csvConfigForm.valid){
      const isLocale = this.csvConfigForm.get('useLocalSettings').value;
      // Assign Browser based LOCALE settings
      if(isLocale){
        this.disableFormState(false);
        this.csvConfigForm.patchValue({
          columnSeperator : this.getColumnSeparator(),
          decimalSeperator : this.getDecimalSeparator(navigator.language)
        })
      }
      const data = {
        csvData :this.csvConfigForm.getRawValue(),
        saveData:true
      };
      this.dialogRef.close(data);
    }
  }
  getDecimalSeparator(locale:string) {
    const number = 10.1;
    return new Intl.NumberFormat(locale).format(number).charAt(2);
  }
  getColumnSeparator() {
    let list = ['a', 'b'];
    let str:string ='';
    if (list.toLocaleString) {
        str = list.toLocaleString();
        if (str.indexOf(';') > 0 && str.indexOf(',') === -1) {
            return ';';
        }
    }
    return ',';
  }
  disableFormState(disableControl:boolean):void{;
    const state = disableControl ? 'disable' : 'enable';
    Object.keys(this.csvConfigForm.controls).forEach((controlName)=>{
      if(controlName !== 'template'){
        this.csvConfigForm.get(controlName)[state]()
      }
    })
  }
  onTemplateValChange():void{
    this.csvConfigForm.get('template').valueChanges.subscribe(
      res => {
        const formVal = this.getConfigRules(res);
        this.csvConfigForm.patchValue(formVal);
      }
    )
  }
  getConfigRules(templateVal:number):any{
    let configChangeVal = {
      comment: 0,
      elevation: 0,
      name: 3,
      latitude: 2,
      longitude: 1,
      decimalSeperator:".",
      columnSeperator:","
    }
    switch(templateVal){
      case 1: 
        configChangeVal = {
            comment: 0,
            elevation: 0,
            name: 3,
            latitude: 2,
            longitude:1,
            decimalSeperator:".",
            columnSeperator:","
          };
        this.disableFormState(true);
        break;
      case 2: 
        configChangeVal = {
            comment: 0,
            elevation: 0,
            name: 3,
            latitude: 1,
            longitude: 2,
            decimalSeperator:",",
            columnSeperator:";"
          };
        this.disableFormState(true);
        break;
      case 3: 
        configChangeVal = {
            comment: 0,
            elevation: 0,
            name: 3,
            latitude: 2,
            longitude: 1,
            decimalSeperator:".",
            columnSeperator:";"
          };
        this.disableFormState(true);
        break;
      case 4: 
        configChangeVal = {
            comment: 7,
            elevation: 0,
            name: 6,
            latitude: 4,
            longitude: 3,
            decimalSeperator:".",
            columnSeperator:","
          };
        this.disableFormState(true);
        break;
      case 5: 
        configChangeVal = {
            comment: 0,
            elevation: 0,
            name: 3,
            latitude: 2,
            longitude: 1,
            decimalSeperator:".",
            columnSeperator:","
          };
        this.disableFormState(false);
        break;
      default: break;
    }
    return configChangeVal;
  }

}
